import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-home-welcome',
  imports: [TranslateModule],
  templateUrl: './home-welcome.component.html',
  styleUrl: './home-welcome.component.scss'
})
export class HomeWelcomeComponent {}
